const NAVIGATION_PANE_PARAMETER = "navpanes";
const COLLAPSED_PARAMETER_VALUE = "0";

/** Allows backend HTTP(S) documents and browser-created object URLs, but no executable schemes. */
export function safePdfDocumentUrl(url?: string | null): string | undefined {
  if (!url) return undefined;

  const trimmed = url.trim();

  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") return trimmed;
    if (parsed.protocol !== "blob:") return undefined;

    const blobOrigin = new URL(parsed.pathname);

    return blobOrigin.protocol === "http:" || blobOrigin.protocol === "https:" ? trimmed : undefined;
  } catch {
    return undefined;
  }
}

/**
 * Collapses Chromium's PDF thumbnail pane without hiding its toolbar. Existing PDF open
 * parameters are preserved, including a bare named destination.
 */
export function withCollapsedPdfNavigationPane(url?: string | null): string | undefined {
  if (!url) return undefined;

  const fragmentIndex = url.indexOf("#");
  const baseUrl = fragmentIndex === -1 ? url : url.slice(0, fragmentIndex);
  const fragment = fragmentIndex === -1 ? "" : url.slice(fragmentIndex + 1);
  const parameters = new URLSearchParams();

  if (fragment && !fragment.includes("=")) {
    parameters.set("nameddest", fragment);
  } else if (fragment) {
    for (const [key, value] of new URLSearchParams(fragment)) parameters.append(key, value);
  }

  parameters.set(NAVIGATION_PANE_PARAMETER, COLLAPSED_PARAMETER_VALUE);

  return `${baseUrl}#${parameters.toString()}`;
}
